import { useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { colors } from "../../../ui/colors"
import { ArrowLeftIcon } from "../../../ui/icons/arrow-left"
import { Layout } from "../../../ui/layout"
import { CustomAccordion } from "../../../ui/molecules/accordion"
import { ButtonComponent } from "../../../ui/molecules/button/newButton"
import { Calendar } from "../../../ui/molecules/calendar"
import { MadfarmInput } from "../../../ui/molecules/input/newInput"
import { ProtocolSearch } from "../../../ui/molecules/ProtocolSearch"
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static"
import TextArea from "../../../ui/molecules/textArea"
import { MenuItems } from "../../../ui/organisms/navbar/dto"
import { SuccessPopup } from "../../../ui/organisms/successPopup"
import { TipoOperatoreDemeter } from "../../../utils"
import { GetAllInspectionVisit } from "../../incarichi/slice"
import { CreateDemeter, resetCreateStatus, setCreateClientType, setCreateCodexNote, setCreateCompanyType, setCreateCustomerId, setCreateDemeterNote, setCreateEdingDate, setCreatePrivacyProtocol, setCreateProcessingType, setCreateStake, setCreateStartingDate, setCreateTerzeParti, setCreateVisitId, setCreateYear } from "./slice"

export function AddCertificazioneDemeter() {
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const [visitOptions, setVisitOptions] = useState<{ value: string; label: string }[]>([]);
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const demeter = useAppSelector(state => state.demeter)
    const [expanded, setExpanded] = useState<string>('panel1')
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const successHandledRef = useRef(false)

    const handleToggleAccordion = (panel: string) => {
        setExpanded(prev => (prev === panel ? '' : panel))
    }

    useEffect(() => {
        dispatch(setCreateCustomerId(sessionState.selected.customerId))
    }, [])

    useEffect(() => {
        if (sessionState.selected.customerId) {
            dispatch(GetAllInspectionVisit({
                itemsPerPage: 0,
                page: 0,
                customerId: sessionState.selected.customerId.toString()
            }))
        }
    }, [])

    useEffect(() => {
        if (assignmentState.getAllInspectionVisitStatus === 'successfully') {
            const visits = assignmentState.getAllInspectionVisitResponse?.data || [];

            const options = visits.map((visit) => ({
                value: visit.id,
                label: new Date(visit.effectiveVisitDate).toLocaleDateString('it-IT') + " " + (visit.reportProtocolInfo ? visit.reportProtocolInfo : ''),
            }));

            setVisitOptions(options);
        }
    }, [assignmentState.getAllInspectionVisitStatus]);

    useEffect(() => {
        if (demeter.demeterCreationStatus === 'successfully') {
            successHandledRef.current = false
            setShowSuccess(true)
        }
    }, [demeter.demeterCreationStatus])

    const handleSuccessClose = () => {
        if (successHandledRef.current) {
            return
        }

        successHandledRef.current = true
        setShowSuccess(false)
        dispatch(resetCreateStatus())
        navigate('/gestioneDemeter')
    }

    return (
        <Layout
            menuItem={MenuItems.USERS}
            breadcrumbItems={['Gestione Demeter', 'Nuovo Demeter']}
            noPaddingLat
            headerLabel="Gestione Demeter"
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/gestioneDemeter')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end gap-2">
                    <ButtonComponent
                        iconPosition='off'
                        variant='solid'
                        color='orange'
                        size='sm'
                        label='Salva'
                        onClick={() => dispatch(CreateDemeter(demeter.createCertDemeter))}
                    />
                </div>
            }
        >
            {
                showSuccess &&
                <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                    <SuccessPopup
                        active={showSuccess}
                        message="Dati salvati correttamente."
                        onClose={handleSuccessClose}
                    />
                </div>
            }
            <div className="p-6 flex flex-col gap-6">
                <CustomAccordion
                    id="panel1"
                    title={<span className="text-uppercase text-white label-input">Dati Demeter</span>}
                    expanded={expanded === 'panel1'}
                    onChange={() => handleToggleAccordion('panel1')}
                    detailsClassName="flex flex-col gap-4"
                >
                    <div className="grid grid-cols-1 gap-4">
                        <MadfarmStaticSelect
                            label="Controllo (elenco controlli)"
                            placeholder={'Visite ispettive'}
                            options={visitOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setCreateVisitId(newValue))
                            }}
                            value={demeter.createCertDemeter.inspectionVisitId}
                            noOptionsMessage={"Nessun risultato trovato"}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <MadfarmInput
                            label={'Anno'}
                            placeholder="Anno"
                            onChangeText={(text) => dispatch(setCreateYear(text))}
                        />
                        <Calendar
                            label={'Data Inizio'}
                            onChange={(date) => dispatch(setCreateStartingDate(date))}
                            selected={demeter.createCertDemeter.startingDate}
                        />
                        <Calendar
                            label={'Data Fine'}
                            selected={demeter.createCertDemeter.endingDate}
                            onChange={(date) => dispatch(setCreateEdingDate(date))}
                        />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                        <MadfarmStaticSelect
                            noOptionsMessage="Nessun risultato trovato"
                            label="Tipo Operatore"
                            placeholder={'Tipo Operatore'}
                            options={TipoOperatoreDemeter}
                            value={demeter.createCertDemeter.operatorType}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setCreateClientType(newValue))
                            }}
                        />
                        <MadfarmInput
                            label={'Tipo Azienda'}
                            placeholder="Tipo Azienda"
                            onChangeText={(text) => dispatch(setCreateCompanyType(text))}
                        />
                        <MadfarmInput
                            label={'Quota'}
                            placeholder="Quota"
                            onChangeText={(text) => dispatch(setCreateStake(text))}
                        />

                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <MadfarmInput
                            label={'Conto Terzi per Azienda'}
                            placeholder="Conto Terzi per Azienda"
                            onChangeText={(text) => dispatch(setCreateTerzeParti(text))}
                        />
                        <MadfarmInput
                            label={'Tipo Lavorazione'}
                            placeholder="Tipo Lavorazione"
                            onChangeText={(text) => dispatch(setCreateProcessingType(text))}
                        />
                    </div>

                    <div className="grid grid-cols-1 gap-4">
                        <ProtocolSearch
                            label="Protocollo Privacy"
                            type='entry'
                            onSelect={(value) => {
                                dispatch(setCreatePrivacyProtocol(value))
                            }}
                        />
                    </div>
                </CustomAccordion>

                <CustomAccordion
                    id="panel2"
                    title={<span className="text-uppercase text-white label-input">Note</span>}
                    expanded={expanded === 'panel2'}
                    onChange={() => handleToggleAccordion('panel2')}
                    detailsClassName="flex flex-col gap-4"
                >
                    <div className="grid grid-cols-1 gap-4">
                        <TextArea
                            label="Note Demeter"
                            onChangeText={(value) => dispatch(setCreateDemeterNote(value))}
                        />
                    </div>
                    <div className="grid grid-cols-1 gap-4">
                        <TextArea
                            label="Note Codex"
                            onChangeText={(value) => dispatch(setCreateCodexNote(value))}
                        />
                    </div>
                </CustomAccordion>
            </div>
        </Layout>
    )
}